import api, { ApiCallReturn } from '../api';

export const getAppConfig = (): ApiCallReturn => api.get('/web/pages/config');
export const getInitApp = (uuid?: string): ApiCallReturn => {
  const headers: Record<string, string> = {};
  if (uuid) {
    headers['app-uuid'] = uuid;
  }
  return api.get('/web/pages/init', {headers});
};
